import React from 'react';
import HorizontalTimelineContent from './HorizontalTimeline';
import Experience from '../../resources/WorkExperience';
import './HorizontalTimeline.scss'

export default class Slider extends React.Component {
  constructor(props) {
    super(props);
    this.eventRef = React.createRef();
    //this.state = { value: 5, previous: 4 };
  }

  componentWillMount() {
    this.data = Experience.map((experience, index) => {
      return ({
        date: experience.date,
        component: (
        <div className="flex flex-col justify-center items-center">
            {/* any arbitrary component can go here */}
            <img src={experience.photo} alt='logo_image' className="expriencePicture mt-3"></img>
            <h4 className='font-Arial text-2xl md:text-3xl lg:text-4xl font-regular mt-5'>{experience.title}</h4>
            <h5 className='font-sans text-lg md:text-xl lg:text-xl mt-2 text-gray-400' >{experience.subtitle}</h5>
            <h5 className='font-sans text-lg italic md:text-xl lg:text-xl mt-2 text-gray-800'>{experience.duration}</h5>
            <p className='font-Arial WorkContent font-regular text-lg md:text-xl font-regular text-center break-words mt-1 md:mt-2'>{experience.content}</p>
        </div>
        )
      });
    });
  }

  render() {
    
    return (
      <HorizontalTimelineContent 
      content={this.data}   
      />
    );
  }
}
